import React from 'react';

import { Conf } from 'presentation/pages';

export const MakeConfFactory: React.FC = (): JSX.Element => {
  return <Conf />;
};
